import { render, staticRenderFns } from "./NuevoDiagnostico.vue?vue&type=template&id=f6408894&scoped=true"
import script from "./NuevoDiagnostico.vue?vue&type=script&lang=js"
export * from "./NuevoDiagnostico.vue?vue&type=script&lang=js"
import style0 from "./NuevoDiagnostico.vue?vue&type=style&index=0&id=f6408894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6408894",
  null
  
)

export default component.exports